import type { ReactNode } from 'react';
import { Box, HStack, Text, VStack } from '../../../components/primitives';
import { colors } from '../../../theme/colors';
import { tokens } from '../../../theme/tokens';

export function ProfileInfoRow({
  icon,
  label,
  value,
}: Readonly<{
  icon: ReactNode;
  label: string;
  value: string;
}>) {
  return (
    <HStack spacing="sm" align="center">
      {icon}
      <VStack spacing="xxs" style={{ flex: 1 }}>
        <Text
          variant="caption"
          uppercase
          color={colors.text.tertiary}
          style={{ fontSize: 10, letterSpacing: 0.8 }}
        >
          {label}
        </Text>
        <Text variant="bodySmall" color={colors.text.primary} style={{ fontWeight: '500' }}>
          {value}
        </Text>
      </VStack>
    </HStack>
  );
}

export function ProfileDivider() {
  return (
    <Box
      height={1}
      backgroundColor={colors.border.muted}
      style={{ marginVertical: tokens.spacing.xs }}
    />
  );
}
